import "./Footer.css";
import LinkedInLogo from "../images/icons/linkedin-logo.svg";
import XLogo from "../images/icons/x-logo.svg";
import HeartIcon from "../images/icons/heart.svg";

export function Footer() {
  return (
    <footer className="footer">
      <p className="footer__tagline">Building the future quietly.</p>
      <p className="footer__text">Serova</p>
      <div className="footer-socials">
        <a
          href="https://www.linkedin.com/company/serovabio/feedView=all"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={LinkedInLogo}
            className="footer-socials__icon"
            alt="LinkedIn"
          />
        </a>
        <a href="https://x.com" target="_blank" rel="noopener noreferrer">
          <img src={XLogo} className="footer-socials__icon" alt="X" />
        </a>
      </div>
      <div className="footer__credits">
        Built with <img src={HeartIcon} alt="heart emoji" /> by{" "}
        <div>
          <a href="https://aideon.co.uk" target="_blank">
            Aideon
          </a>
          .
        </div>
      </div>
    </footer>
  );
}
